import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Customer } from 'src/app/shop';

@Component({
    selector: 'app-profile-card',
    templateUrl: './profile-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProfileCardComponent {
  @Input() customer!: Customer;
  @Input() prefix: string = 'profiel-card';
  @Input() hasAdress = false;
  @Input() hasVatNumber = false;

  constructor() {}
}
